<template>
	<div class="membody">
		<div class="mheader page-container-padding">
			<div>
				<div>团队邀请码</div>
				<div class="tag-read" @click="copyCode">{{postparams.groupcode}}</div>
				<img  src="@/images/info@3x.png" @click="showInviteTips"/>
			</div>
			<div>
				<Button class="sharein" type="warning" size="small" round @click="sharein">邀请成员</Button>
			</div>
		</div>
		<div class="page-container-padding" style="padding-bottom:70px;" v-if="memberList.length">
			<div class="memberbodyheader">共{{memberList.length}}成员 男 {{boy}} 女{{girl}}</div>
			<div class="memberbody" v-for="item in memberList" :key="item.id">
				<div :class="['radiusshadow page-container-padding', item.sex == '男' ? 'man' : 'girl' ]">
					<div>
						<div>{{item.name}}</div>
						<div>{{item.mobile}}</div>
					</div>
					<div>
						<Button class="mvbuttonplain" plain type="warning" size="mini" round @click="delmember(item)">删除</Button>
						<Button class="mvbuttonplain" plain type="warning" size="mini" round @click="addMember(item)">修改</Button>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="line">
			<Divider>暂无成员,请添加</Divider>
		</div>
		<div class="memberfooter page-container-padding footer">
			<Button  plain type="warning" round @click="importMember">从团队库导入</Button>
			<Button  type="warning" round @click="addMember(item = false)" >添加成员</Button>
		</div>
	</div>
</template>

<script>
	import './member.less'
    import {matchinfo,delpremember,prememberlist} from '@/libs/api'
    import {Button,Dialog,Divider,Toast} from 'vant'
    import Clipboard from 'clipboard'
    import {setStorage, getStorage} from '@/libs/utils'

    export default {
        name: 'mainapply',
        components: {
            Button,
            Divider
        },
		data() {
			return {
				postparams: {},
				memberList: {},
				registermatchinfo: {},
				boy: 0,
				girl: 0
			}
		},
		methods:{
			delmember(item){
				Dialog.confirm({
					title: '提示',
					message: '确定删除该成员？'
				}).then(() => {
					this.postparams.riid = item.riid
					this.postparams.memberid = item.memberid
					delpremember(this.postparams).then((res)=>{
						if(res.status==200)
						{
						this.memberlist()
						}
					})
					// on close
				});
			},
			addMember(item){
				var postparams = this.postparams;	        
				var riid = item.riid;
				if(riid)
				{
					postparams.riid =   riid;
				}else{
					delete postparams.riid;
				}

				this.$router.replace({name:'adduser',params:postparams});
			},
			importMember(){
				var postparams  =   this.postparams;
				this.$router.replace({name:'userslist',params:postparams});
			},
			copyCode(){
				var Url = this.postparams.groupcode
				var clipboard = new Clipboard('.tag-read', {
					text: function() {
					return Url;
					}
				});
				clipboard.on('success', () => {
					Toast.success({message:'复制成功!',duration:1000});
					// 释放内存
					clipboard.destroy()
				})
				clipboard.on('error', () => {
					// 不支持复制
					Toast.fail({message:'该浏览器不支持自动复制!',duration:1000});
					// 释放内存
					clipboard.destroy()
				})
			},
			showInviteTips(){
				Toast({message:'其他用户可以通过该邀请码加入您的团队.点击邀请码可以复制',duration:1000});
			},
			matchInfo(){
				matchinfo(this.postparams).then((res) => {
					if (res.status == 200) {
						if (res.data) {
							this.registermatchinfo = res.data

						}

					}
				})
			},
			memberlist(){
				prememberlist(this.postparams).then((res)=>{
					if (res.status == 200) {
						var boy = 0, girl = 0;
						if (res.data) {
							res.data.list.forEach((item) => {

								item.attrs.forEach((citem) => {
									if (citem.key_name == 'mv_name') {
										item.name = citem.value;
									}
									if (citem.key_name == 'mv_mobile') {
										item.mobile = citem.value;
									}
									if (citem.key_name == 'mv_sex') {
										item.sex = citem.value;
										if(item.sex=='男')
										{
											boy++;
										}
										if(item.sex=='女')
										{
											girl++;
										}
									}

								})
							})
							this.memberList = res.data.list
							this.boy = boy
							this.girl = girl
						}
					}
				})
			},
			sharein(){
				var Url =window.location.protocol+'//'+window.location.hostname+':'+window.location.port+'/invitemember/'+this.postparams.matchid
				var clipboard = new Clipboard('.sharein', {
					text: function() {
					return Url;
					}
				});
				clipboard.on('success', () => {
					Toast.success({message:'团队报名地址复制成功!',duration:1000});
					// 释放内存
					clipboard.destroy()
				})
				clipboard.on('error', () => {
					// 不支持复制
					Toast.fail({message:'该浏览器不支持自动复制!',duration:1000});
					// 释放内存
					clipboard.destroy()
				})
				// this.$router.push({name:'invitemember',params:{matchid:this.postparams.matchid}});
			}
		},
		mounted() {
			this.$nextTick(() => {
				let userinfo = getStorage('userInfo')
				let param = this.$route.params
				let arr = Object.keys(param);
				if(arr.length == 0){
					this.postparams = getStorage('member')
				}else{
					this.postparams = this.$route.params
					setStorage('member',this.postparams,true)
				}
				this.postparams.urid = userinfo.urid
				this.postparams.token = userinfo.token
				this.matchInfo()
				this.memberlist()
			})
		}
        
    }
</script>